import type { TFunction } from "i18next";
import type { FacilityMutationError } from "./useFacilityMutations.js";

/**
 * Machine code → friendly copy for facility mutation failures (the server is authoritative on the outcome; this only
 * translates its codes for humans). Shared by the create/edit UIs so the wording can't drift.
 */
const ERROR_KEY = {
  FACILITY_ARCHIVED: "facilityManagement.errors.facilityArchived",
  FACILITY_FORBIDDEN: "facilityManagement.errors.facilityForbidden",
  // Name-only create/rename — keep the copy about the name (categories are attached separately now).
  FACILITY_INVALID: "facilityManagement.errors.facilityInvalid",
  FACILITY_NOT_FOUND: "facilityManagement.errors.facilityParentGone",
} as const;

/** Map a thrown mutation error to friendly copy, falling back to a generic message. */
export function facilityErrorCopy(err: unknown, t: TFunction, fallbackKey = "facilityManagement.errors.facilityCreateFailed" as const): string {
  const code = (err as FacilityMutationError | undefined)?.code;
  const key = code && code in ERROR_KEY ? ERROR_KEY[code as keyof typeof ERROR_KEY] : fallbackKey;
  return t(key);
}
